<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">View Detail - {{ batchJobDetail.batchJobId }}</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <div v-resize="elSizeChange" class="a-body flex-grow-1">
      <transition name="slide-up">
        <div v-if="!isLoading">
          <h3 class="px-20-px pt-20-px mb-0">
            Crawl Summary
          </h3>
          <p class="mb-0" v-if="!dataCrawlSummary.length">
            No results yet ! Please check later.
          </p>
          <PaginationTable
            v-if="dataCrawlSummary.length"
            :pagination="pagin"
            :columns="CrawlSummaryColumns"
            :dataSource="dataCrawlSummary">
            <template slot="domain" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  {{ record.domain }}
                </p>
              </div>
            </template>
            <template slot="initialURL" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  {{ record.initialURL }}
                </p>
              </div>
            </template>
            <template slot="userAgentId" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  {{ userAgentsData[record.userAgentId].alias }}
                </p>
              </div>
            </template>
            <template slot="startedOn" slot-scope="{ record }">
              <div>
                <p class="mb-0">{{ record.startedOn | dateString }}</p>
                <p class="mb-0">{{ record.startedOn | timeString }}</p>
              </div>
            </template>
            <template slot="endedOn" slot-scope="{ record }">
              <div>
                <p class="mb-0">{{ record.endedOn | dateString }}</p>
                <p class="mb-0">{{ record.endedOn | timeString }}</p>
              </div>
            </template>
            <template slot="crawlStatus" slot-scope="{ record }">
              <a-tag :color="tagStatusColor(record.crawlStatus)">
                {{ record.crawlStatus }}
              </a-tag>
            </template>
          </PaginationTable>
          <div class="p-20-px">
            <h3>
              Crawl Result
            </h3>
            <div class="collapes-sections">
              <template v-for="levelSection in dataCrawlResult">
                <a-collapse :key="levelSection.level" :bordered="true">
                  <template #expandIcon="props">
                    <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
                  </template>
                  <a-collapse-panel :showArrow="true" class="collapse-panel">
                    <template slot="header">
                      <div class="collapse-header">
                        <div class="collapse-header__label">
                          Level {{ levelSection.level }}
                        </div>
                      </div>
                    </template>
                    <div class="table-wrapper">
                      <div class="section-table-container">
                        <PaginationTable
                          :clientPaging="false"
                          :columns="CrawlDetailColumns"
                          :dataSource="levelSection.urls"
                          >
                        </PaginationTable>
                      </div>
                    </div>
                  </a-collapse-panel>
                </a-collapse>
              </template>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="a-footer">
    </div>
  </div>
</template>

<script>
  import { groupBy } from 'lodash';
  import DataService from '@shared/services/data.service';
  import { BatchJobStatusColorTag, BatchJobStatus } from '../consts/BatchJob.consts';
  import BatchJobService from '../services/BatchJob.service';
  import { CrawlSummaryColumns } from '../columnsTable/CrawlSummaryColumns';

  const CrawlDetailColumns= [
    {
      title: 'No.',
      dataIndex: 'index',
      width: 100
    },
    {
      title: 'URL',
      dataIndex: 'url',
    },
  ];

  export default {
    name: 'BatchJobDetailCrawl',
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        CrawlSummaryColumns,
        CrawlDetailColumns,
        userAgentsData: {},
        batchJobDetail: {
          batchJobId: '',
          batchJobRawId: '',
          jobType: '',
          dateAdded: '',
          status: BatchJobStatus.Finished
        },
        dataCrawlSummary: [],
        dataCrawlResult: [],
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    computed: {
      tagStatusColor() {
        return (status) => {
          switch (status) {
            case BatchJobStatus.Completed:
            case BatchJobStatus.Finished: {
              return BatchJobStatusColorTag.Finished;
            }
            case BatchJobStatus.Cancelled: {
              return BatchJobStatusColorTag.Cancelled;
            }
            default: {
              return BatchJobStatusColorTag.NotFinished;
            }
          }
        };
      }
    },
    beforeMount() {
      this.batchJobDetail.batchJobId = this.$route.params.id;
      this.batchJobDetail.batchJobRawId = (this.$route.params.id || '').replace('CR', '');
    },
    mounted() {
      this.fetchList();
    },
    methods: {
      async fetchDetailCrawlJob() {
        const batchJobDetailData = await BatchJobService.fetchDetailsOfBatchCrawlJobById(this.batchJobDetail.batchJobRawId);
        this.dataCrawlSummary = [
          {
            id: batchJobDetailData.id,
            domain: batchJobDetailData.domain,
            initialURL: batchJobDetailData.seed_url,
            userAgentId: batchJobDetailData.user_agent_id,
            depth: batchJobDetailData.depth,
            startedOn: batchJobDetailData.start,
            endedOn: batchJobDetailData.end,
            crawlStatus: batchJobDetailData.status,
          },
        ];
        this.dataCrawlResult = (batchJobDetailData.urls_by_level || []).map((urlCrawled, index) => ({
          level: index,
          urls: (urlCrawled || []).map((url, indexUrl) => ({
            url,
            index: indexUrl + 1,
          })),
        }));
        if (batchJobDetailData.status !== 'Completed') {
          setTimeout(() => {
            this.fetchDetailCrawlJob();
          }, 5000);
        }
      },
      async fetchList() {
        try {
          const userAgentsData = await DataService.getUserAgents();
          await this.fetchDetailCrawlJob();
          this.userAgentsData = Object.fromEntries(Object.entries(groupBy(userAgentsData || [], 'id')).map(([keyItem, valueItem]) => ([keyItem, valueItem && valueItem[0] || {}])));
          this.isLoading = false;
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 30000);
          }
        }
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .time-text {
    margin-bottom: 0;
    white-space: nowrap;
  }
  .nav-link-detail {
    &:hover {
      text-decoration: underline;
    }
  }
  .section-table-container {
    overflow-x: auto;
  }
  ::v-deep {
    .ant-collapse.ant-collapse-icon-position-left {
      margin-top: 20px;
    }
    .ant-collapse-borderless {
      background-color: #ffffff;
    }
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0;
    }
    .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
      padding: 0;
    }

    .ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
      padding: 20px;
      background-color: #dedede;
    }
    .ant-collapse-borderless > .ant-collapse-item {
      border-bottom: none;
    }
  }
  .collapes-sections {
    padding: 0;
  }
  .collapse-panel {
    background-color: transparent;
  }
  .collapse-header {
    box-sizing: border-box;
    border-radius: 4px;
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    &__label {
      color: #323232;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 20px;
    }
    &__redirect {
      color: #20a4b8;
      font-family: Roboto;
      font-size: 13px;
      letter-spacing: 0;
      line-height: 20px;
      text-align: right;
    }
  }
</style>
